import React from "react";
import Wprr from "wprr";

export default class ImageGallery extends Wprr.BaseObject {
	
	constructor(aProps) {
		super(aProps);
	}

	_renderMainElement() {
		
		let images = this.getFirstInput("images");

		const imageElements = images.map((item, index) => {
			
			let imageUrl = Wprr.objectPath(item, "image.url");
			
			return (
				<div className="gallery-item">
					<div className="image-container">
						<Wprr.Image
							src={imageUrl}
							className="gallery-image background-cover "
						/>
					</div>
				</div>
			);
		});
		
		let mobileElement = null;
		let tabletElement = null;
		let desktopElement = null;
		
		switch(images.length) {
			case 1:
				mobileElement = <div className="image-gallery__container mobile-gap ">
					<div className="column-4 row-1">{imageElements[0]}</div>
				</div>;
				tabletElement = <div className="image-gallery__container">
					<div className=" column-4 row-2">{imageElements[0]}</div>
				</div>;
				desktopElement = <div className="image-gallery__container">
					<div className=" column-4 row-2">{imageElements[0]}</div>
				</div>;
				break;
			case 2:
				mobileElement = <div className="image-gallery__container mobile-gap grid-2">
					<div className="column-2 row-1">{imageElements[0]}</div>
					<div className="column-2 row-1">{imageElements[1]}</div>
				</div>;
				tabletElement = <div className="image-gallery__container">
					<div className="column-2 row-2">{imageElements[0]}</div>
					<div className="column-2 row-2">{imageElements[1]}</div>
				</div>;
				desktopElement = <div className="image-gallery__container">
					<div className="column-2 row-2">{imageElements[0]}</div>
					<div className="column-2 row-2">{imageElements[1]}</div>
				</div>;
				break;
			case 3:
				mobileElement = <div className="image-gallery__container mobile-gap grid-3">
					<div className="column-4 row-2">{imageElements[0]}</div>
					<div className="column-2 row-1">{imageElements[1]}</div>
					<div className="column-2 row-1">{imageElements[2]}</div>
				</div>;
				tabletElement = <div className="image-gallery__container three-columns grid-3">
					<div className="column-3 row-1">{imageElements[0]}</div>
					<div className="column-3 row-1">{imageElements[1]}</div>
					<div className="column-3 row-1">{imageElements[2]}</div>
				</div>;
				desktopElement = <div className="image-gallery__container three-columns grid-3">
					<div className="column-3 row-2">{imageElements[0]}</div>
					<div className="column-3 row-2">{imageElements[1]}</div>
					<div className="column-3 row-2">{imageElements[2]}</div>
				</div>;
				break;
			case 4:
				mobileElement = <div className="image-gallery__container mobile-gap grid-4">
					<div className="column-2 row-1">{imageElements[0]}</div>
					<div className="column-2 row-1">{imageElements[1]}</div>
					<div className="column-2 row-1">{imageElements[2]}</div>
					<div className="column-2 row-1">{imageElements[3]}</div>
				</div>;
				tabletElement = <div className="image-gallery__container">
					<div className="column-2 row-2">{imageElements[0]}</div>
					<div className="column-2 row-1">{imageElements[1]}</div>
					<div className="column-1 row-1">{imageElements[2]}</div>
					<div className="column-1 row-1">{imageElements[3]}</div>
				</div>;
				desktopElement = <div className="image-gallery__container">
					<div className="column-2 row-2">{imageElements[0]}</div>
					<div className="column-2 row-1">{imageElements[1]}</div>
					<div className="column-1 row-1">{imageElements[2]}</div>
					<div className="column-1 row-1">{imageElements[3]}</div>
				</div>;
				break;
		}

		let mobileLayout = <div className="full-width">{mobileElement}</div>;
		let tabletLayout = <div className="full-width">{tabletElement}</div>;
		let desktopLayout = <div className="full-width">{desktopElement}</div>;

		let responsiveLayout = Wprr.creators.responsiveTemplate(mobileLayout);
		responsiveLayout.addResponsiveTemplate(tabletLayout, 600);
		responsiveLayout.addResponsiveTemplate(desktopLayout, 1100);
		return <div> {responsiveLayout.getReactElements()} </div>;
	}
}
